// ---------------------------------------------------------------------------
// Centralized API base URL for the WhatsApp Bot UI.
//
// Background:
// Emergent's "Deploy" button only deploys React + FastAPI - the Node.js
// Baileys gateway (port 8002, supervisor-managed) does NOT get deployed.
// The full WhatsApp stack lives on the always-running preview environment.
//
// Strategy:
// - When the user opens the bot on the *preview* host (or localhost) we use
//   the regular REACT_APP_BACKEND_URL (relative to this host).
// - When the user opens the bot on the *production* host (the deployed
//   menshealth.co.il / *.emergent.host etc.) we transparently route every
//   wabot API call to the always-running preview backend, so the user can
//   manage WhatsApp from their main bookmarked domain instead of having to
//   keep two URLs.
//
// CORS is permissive on the backend (`CORS_ORIGINS=*`) so the cross-origin
// XHR/fetch from prod -> preview works without any extra config.
// ---------------------------------------------------------------------------

// Hardcoded fallback - the preview environment that always runs the Node.js
// Baileys gateway alongside the FastAPI backend. Kept as a constant so it
// can be rotated in one place if the preview URL ever changes.
const PREVIEW_BACKEND_URL = 'https://wellness-order-2.preview.emergentagent.com';

const isPreviewHost = () => {
  if (typeof window === 'undefined') return true; // SSR safety
  const h = window.location.hostname;
  return h.includes('preview.emergentagent.com') || h === 'localhost' || h.startsWith('127.');
};

// Base origin used by every wabot fetch/axios call. On production it's the
// preview URL; on preview it's whatever the env file says (which is the
// preview URL itself in practice).
export const WABOT_BACKEND_ORIGIN = isPreviewHost()
  ? (process.env.REACT_APP_BACKEND_URL || '')
  : PREVIEW_BACKEND_URL;

export const WABOT_API = `${WABOT_BACKEND_ORIGIN}/api`;

// Helper for media URLs (uploaded images / videos served by the backend).
export const wabotMediaUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  return `${WABOT_BACKEND_ORIGIN}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const isProductionHost = () => !isPreviewHost();
